import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ServicesGrid } from './components/ServicesGrid';
import { FoodCombos } from './components/FoodCombos';
import { ProductGrid } from './components/ProductGrid';
import { ShippingBanner } from './components/ShippingBanner';
import { TrustMetrics } from './components/TrustMetrics';
import { EmotionalSection } from './components/EmotionalSection';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ServicesGrid data-id="element-4" />
        <FoodCombos data-id="element-5" />
        <ProductGrid data-id="element-6" />
        <ShippingBanner data-id="element-7" />
        <TrustMetrics data-id="element-8" />
        <EmotionalSection data-id="element-9" />
        <Testimonials data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}